<template>
  <div>
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button
          icon="fa fa-plus"
          @click="insertEvent()"
        >
          新增
        </vxe-button>
        <vxe-button
          icon="fa fa-save"
          @click="getInsertEvent"
        >
          获取新增
        </vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      class="my_table_insert"
      max-height="400"
      :data="tableData"
      :checkbox-config="{highlight: true}"
      :edit-config="{trigger: 'click', mode: 'cell', icon: 'fa fa-pencil'}"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column
        field="name"
        title="费用类型"
        sortable
        :edit-render="{name: 'input', defaultValue: '100'}"
      />
      <vxe-table-column
        field="sex"
        title="费用"
        :edit-render="{name: 'input'}"
      />
      <vxe-table-column
        field="sex"
        title="费用类型"
        width="140"
        :edit-render="{type: 'default'}"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.sex"
            @change="$refs.xTable.updateStatus(scope)"
          >
            <el-option
              v-for="item in sexList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
        <template v-slot="{ row }">
          {{ getSelectLabel(row.sex, sexList) }}
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="age"
        title="备注"
        sortable
      />
    </vxe-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: []
    }
  },
  created() {},
  methods: {
    async insertEvent(row) {
      const record = {
        sex: '1'
      }
      const { row: newRow } = await this.$refs.xTable.insertAt(record, row)
      await this.$refs.xTable.setActiveCell(newRow, 'sex')
    },
    getInsertEvent() {
      // const insertRecords = this.$refs.xTable.getInsertRecords()
    },
    getSelectionEvent() {
      // const removeRecords = this.$refs.xTable.getCheckboxRecords()
    }
  }
}
</script>
<style lang="scss">
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
.my_table_insert .vxe-body--row.row--new {
  background-color: #f1fdf1;
}
</style>

<style>
    
</style>
